/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.divider {
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.2);
  margin-block: 0px;
  margin-inline: 1.5em;
}
.divider + li:not([role="option"]) {
  margin-top: calc(var(--spacing, 0.25rem) * 4);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
